import React, { useEffect, useState } from 'react';
import { PAGE_MAX_WIDTH, PAGE_PADDING } from '../constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons';
import useMobileOrTablet from 'src/hooks/useMediaQuery';
import styled from 'styled-components';
import { Helmet } from "react-helmet";
import { scrollToTop } from 'src/utils';

const ToTopButton = styled(FontAwesomeIcon)`
    transition: all 0.4s;
    &:hover,
    &:active {
        transform: scale(1.1);
    }
`;

export default function LoginLayout({ children }) {
    const isMobileOrTablet = useMobileOrTablet()
    const [onTop, setOnTop] = useState(true);

    useEffect(() => {
        window.onscroll = () => {
            if (window.pageYOffset <= 50) {
                onTop === false && setOnTop(true)
            } else {
                onTop === true && setOnTop(false)
            }
        }

        return () => (window.onscroll = null);
    });

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                flex: 'column',
            }}
        >

            <Helmet>
                <meta charSet="utf-8" />
                <title>Hidiarch Studio</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <link
                    href="https://bio.linkcdn.to/20210809/1628520221869.jpeg"
                    rel="icon"
                />
            </Helmet>

            <div style={{
                alignItems: 'center',
                backgroundImage: `url(${require('src/assets/images/wallpaper-green.jpeg')})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                position: 'fixed',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: -100
            }} />

            <div style={{ maxWidth: PAGE_MAX_WIDTH, padding: PAGE_PADDING, paddingTop: 0, minWidth: 100, height: '100vh' }}>
                {children}
                <p style={{textAlign: 'center', opacity: 0}}>-----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------</p>
            </div>

            {!onTop && <ToTopButton
                icon={faAngleUp}
                onClick={scrollToTop}
                style={{
                    position: 'fixed',
                    bottom: isMobileOrTablet ? 20 : 20,
                    right: isMobileOrTablet ? 20 : 20,
                    backgroundColor: 'white',
                    width: isMobileOrTablet ? 20 : 20,
                    height: isMobileOrTablet ? 20 : 20,
                    padding: 10,
                    borderRadius: 50,
                    overflow: 'hidden',
                    cursor: 'pointer',
                }} />
            }
        </div>
    )
}